<template>
  <div
    v-if="state.mainDialog"
    class="all-dialog"
  >
    <div class="header">
      <span class="title">{{ state.currentSit.c2 }}</span>
      <span
        class="close"
        @click="close"
      >
        <el-icon><close-bold /></el-icon>
      </span>
    </div>
    <div class="nav">
      <div class="left">
        <el-button
          v-for="(item,index) in state.navList"
          :key="index"
          type="primary"
          class="radio-button"
          :disabled="item.disabled"
          :class="state.navIndex===index?'active':''"
          @click="changeNav(index)"
        >
          {{ item.label }}
        </el-button>
        <!-- 冷源系统和空调机组展示组态按钮 -->
        <el-button
          v-if="state.currentSit.equipTypeId==='1211103'
            ||state.currentSit.equipTypeId.indexOf('12121')>-1"
          type="primary"
          class="radio-button"
          :class="state.configurationDialog?'active':''"
          @click="handelModel"
        >
          组态
        </el-button>
      </div>

      <div
        v-if="state.navIndex===2"
        class="right"
      >
        <el-select
          v-model="state.pointIds"
          class="m-2"
          placeholder="选择指定的属性"
          multiple
          clearable
          collapse-tags
          collapse-tags-tooltip
          style="width: 340px;"
          @change="openRunHistory"
        >
          <el-option
            v-for="(item) in state.mainData"
            :key="item.shortPointId"
            :label="item.pointType"
            :value="item.shortPointId"
          />
        </el-select>
      </div>
    </div>
    <div class="content">
      <div
        v-if="state.navIndex===0"
        class="device-type"
      >
        <div
          v-for="item in state.mainData"
          :key="item.pointId"
          class="line"
          :class="item.n4Status==='alarm'?'alarm':''"
        >
          <span class="label">{{ item.pointType }}:</span>
          <span
            v-if="item.schedulabled"
            class="value"
          >
            <input
              v-model="item.pointValue "
              type="text"
              style="width: 20px;"
            />
            <el-button
              type="primary"
              style="height: 22px;margin-left: 4px;"
              @click="setPointVal(item)"
            >
              设置
            </el-button>
          </span>
          <span v-else-if="item.switchabled||item.manualabled">
            <el-switch
              v-model="item.pointValue"
              inline-prompt
              active-value="1"
              inactive-value="0"
              active-text="启动"
              inactive-text="停止"
              @change="setPointState(item)"
            />
          </span>
          <span
            v-else
            class="value"
          >
            {{ item.displayValue }}
          </span>
        </div>
      </div>
      <div
        v-if="state.navIndex===1"
        v-loading="dialogLoading"
        class="history-content"
      >
        <div class="line">
          <span class="label">运行时间:</span>
          <span class="content">
            <span class="value1"> 8:00-20:00</span>
            <span class="value1"> 20:00-8:00</span>
          </span>
        </div>
        <div class="line">
          <span class="label">状态设定:</span>
          <span class="content">
            <span class="value1"> 8:00-20:00 <span> 22 °C</span></span>
            <span class="value1"> 20:00-8:00  <span> 16 °C</span></span>
          </span>
        </div>
      </div>
      <div
        v-if="state.navIndex===2"
        v-loading="dialogLoading"
        class="history-content"
      >
        <chart-content
          v-if="Object.keys(state.chartResult).length > 0"
          :result="state.chartResult"
          :chart-type="1"
          :equipments="state.mainData"
        />
      </div>
    </div>
  </div>
  <div
    v-if="state.configurationDialog"
    class="configuration"
  >
    <div
      class="close1"
      @click="state.configurationDialog=false"
    >
      <el-icon><close-bold /></el-icon>
    </div>
    <iframe
      :key="state.configurationSrc"
      :src="state.configurationSrc"
      frameborder="0"
      width="100%"
      height="100%"
      style="position: relative;"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
  import {
    ref, onMounted, nextTick, computed, watch,
    reactive,
  } from 'vue';
  import {
    handelControl, setValueImpl, getEquipmentPoint, historySearch,
  } from '@/api/modules/ibms';
  import { ElMessage } from 'element-plus';
  import { useOrgStore } from '@/store/org';
  import {
    CloseBold,
  } from '@element-plus/icons-vue';
  import ChartContent from './chartContent.vue';

  const emit = defineEmits(['close', 'updata']);
  const orgStore = useOrgStore();
  const orgId = computed(() => orgStore.currentOrgInfo.orgId);
  const dialogLoading = ref(false);
  const props = defineProps({
    mainDialog: {
      type: Boolean,
      default: false,
    },
    mainData: {
      type: Array,
      default: () => [],
    },
    currentSit: {
      type: Object,
      default: () => {},
    },
  });
  const state = reactive<any>({
    mainDialog: props.mainDialog,
    mainData: props.mainData,
    currentSit: props.currentSit,
    navIndex: 0,
    pointIds: [],
    chartResult: {}, // 图表结果
    navList: [{
                label: '设备状态',
              },
              {
                label: '运行时间',
                disabled: true,
              },
              {
                label: '运行历史',
              }
    ],
    configurationDialog: false,
    configurationSrc: '', // 组态图动态的src地址
  });
  const openRunHistory = () => {
    const beginTime = (new Date()).getTime() - 24 * 60 * 60 * 1000;
    const endTime = (new Date()).getTime();
    if (state.pointIds.length > 5) {
      ElMessage({
        message: '最多选择5个属性',
        type: 'error',
      });
      state.pointIds = state.pointIds.slice(0, 5);
      return;
    }
    if (state.pointIds.length === 0) {
      state.pointIds.push(state.mainData[0].shortPointId);
    }
    const pointIds = state.pointIds;
    const data = {
      beginTime,
      endTime,
      pointIds,
      orgId: orgId.value,
    };
    dialogLoading.value = true;
    historySearch(data).then((res) => {
      dialogLoading.value = false;
      nextTick(() => {
        state.chartResult = res.data;
      });
    });
  };
  const changeNav = (index:number) => {
    state.navIndex = index;
    if (index === 2) {
      state.navIndex = index;
      openRunHistory();
    }
  };
  const handelModel = () => {
    state.configurationDialog = true;
    state.configurationSrc = `${
      import.meta.env.VITE_APP_ORIGIN
    }/configuration?deviceType=${state.currentSit.equipTypeId}&equipCode=${state.currentSit.c1}`;
  };
  const close = () => {
    state.navIndex = 0;
    state.mainDialog = false;
    emit('close', false);
  };
  const setPointVal = (item:any) => {
    setValueImpl({
      pointId: item.pointId,
      value: item.pointValue,
      orgId: orgId.value,
      equipCode: state.currentSit.c1,
    }).then((res) => {
      if (res.code === 0) {
        emit('updata');
        ElMessage({
          message: res.msg || '设置成功',
          type: 'success',
        });
      }
    });
  };
  const setPointState = (item:any) => {
    const { ca, cb, c1 } = state.currentSit;
    const data = {
      orgId: orgId.value,
      amPointId: (ca && ca.pointId) || '',
      autoManual: item.manualabled ? '1' : '0',
      ctPointId: (cb && cb.pointId) || '',
      equipCode: c1,
      statStop: item.pointValue,
    };
    if (data.amPointId === '' || data.ctPointId === '') {
      return;
    }
    console.log('修改参数222', data, item);
    handelControl(data).then((res) => {
      if (res.code === 0) {
        emit('updata');
        ElMessage.success(res.msg);
      }
    });
  };
  watch(() => props.mainData, (val) => {
          const data = (val || []).map((item:any) => ({
            ...item,
            pointValue: item.pointValue || '0',
          }));
          state.mainData = data.sort((a:any, b:any) => a.pointType - b.pointType);
          sessionStorage.setItem('ibms-device-points', JSON.stringify(state.mainData));
          state.pointIds = [state.mainData[0].shortPointId];
        },
        { immediate: true });

  watch(() => props.currentSit, (val) => {
          state.currentSit = val;
          state.configurationDialog = false;
        },
        { immediate: true });
  /*
   * onMounted(() => {
   *   state.mainData = (props.mainData || []).map((item:any) => ({
   *     ...item,
   *     pointValue: item.pointValue || '0',
   *   }));
   * });
   */

</script>

<script lang="ts">

</script>
<style lang="scss" scoped>
// ::-webkit-scrollbar {
//   width: 2px;
// }

.configuration{
  position: fixed;
  top: 55px;
  left: 210px;
  width: calc(100vw - 540px);
  height: calc(100vh - 450px);
  padding: 30px 10px 10px;
  overflow: hidden;
  border-radius: 6px;

  .close1{
    position: absolute;
    top: 4px;
    right: 10px;
    line-height: 30px;
  }

  &:before{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(6px);
    content: '';
  }
}

.all-dialog{
  position: fixed;
  bottom: 10px;
  left: 210px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(100vw - 540px);
  height: 340px;
  padding: 0 10px;
  overflow: hidden;
  border-radius: 6px;

  &:before{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(6px);
    content: '';
  }

  .header{
    position: relative;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: left;

    .title{
      display: inline-block;
      margin: 5px 8px 0 0;
    }

    .close{
      position: absolute;
      top: 4px;
      right: 10px;
    }
  }

  .nav{
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 30px;
    margin: 8px 0;

    .right{
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }

    .radio-button {
      opacity: 0.4;
    }

    .active{
      opacity: 1;
    }
  }

  .content{
    position: relative;
    flex: 1;
    width: 100%;
    padding-top: 4px;
    padding-bottom: 8px;
    overflow: auto;

    .device-type{
      display: flex;
      flex-flow: column wrap;
      align-content: flex-start;
      justify-content: flex-start;
      width: 100%;
      height: 100%;

      .line{
        display: flex;
        align-items: center;
        width: 30%;
        height: 20px;
        margin-bottom: 6px;
        font-size: 14px;

        .label{
          display: inline-block;
          width: 120px;
          margin-right: 4px;
          text-align: right;
        }

        .value{
          display: inline-block;
          margin-left: 10px;
          overflow: hidden;
        }
      }

      .alarm{
        color: #F56C6C;
      }
    }

    .history-content{
      position: relative;
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;

      .line{
        display: flex;
        margin-bottom: 8px;
        font-size: 14px;

        .label{
          display: inline-block;
          width: 80px;
          line-height: 22px;
          text-align: right;
        }

        .content{
          display: flex;
          flex: 1;
          flex-direction: column;
          margin-left: 10px;
          overflow: hidden;

          .value1{
            display: inline-block;
            margin-bottom: 4px;

            span{
              display: inline-block;
              margin-left: 4px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-height: 750px) {
  .configuration{
    height: 50vh !important;
  }

  .all-dialog{
    height: 30vh !important;
  }
}

</style>
